import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const UploadIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M11.65 15.45v-8.8L9.4 8.9l-.5-.5L12 5.3l3.1 3.1-.5.5-2.25-2.25v8.8h-.7ZM5.3 18.7v-3.75H6V18h12v-3.05h.7v3.75H5.3Z"
      />
    </svg>
  </IconWrapper>
));
